import {BREAK_POINTS} from './settings';
import pcAddIshover from './module/pcAddIshover';
import tab from './module/tab';

// Load the IFrame Player API code asynchronously.
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/player_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
// Replace the 'ytplayer' element with an <iframe> and
// YouTube player after the API code downloads.
var player;
var iframe;
function onYouTubePlayerAPIReady() {
	player = new YT.Player('ytplayer', {
		height: '315',
		width: '560',
		videoId: 'PLjtyTLL448',
		playerVars: {
			controls: 0,
			showinfo: 0
		},
		events: {
			'onReady': onPlayerReady
		}
	});
}
function onPlayerReady(e) {
	iframe = e.target;
	// e.target.playVideo();
	$('.js-yplay').on('click', function() {
		$('#js-movie-modal').fadeIn(function(){
			iframe.playVideo();
		});
	})
	$('.js-movie-close').on('click', function() {
		iframe.stopVideo();
		$('#js-movie-modal').fadeOut();
	})
}

(function () {

  window.addEventListener('DOMContentLoaded', function(e) {
		if ( window.innerWidth >= BREAK_POINTS.gtTAB) {
			document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=1100');
		}
    pcAddIshover();
		tab();
		$('.kd-wrapper a').off();
		$('.kd-wrapper a').on('click', function() {
			var href = $(this).attr('href');
			if(href.match(/^#/) && $(href).length > 0) {
				e.preventDefault();
				$('html, body').animate({ scrollTop: $(href).offset().top - $('.kd-nav').height() - $('#header').height() + 2 }, 800);
			}
		});

		const hash = location.hash;
		if(hash) {
			$(window).scrollTop($(hash).offset().top - $('.kd-nav').height() - $('#header').height() + 2);
		}

		$('.js-acc-btn').on('click', function() {
			$(this).next().slideToggle();
			$(this).toggleClass('is-open');
			$(this).find('.kd-icon').toggleClass('is');

			console.log($(this).next().find('.kd-pbox__items'));
			if($(this).next().hasClass('js-scc-el')) {
				$(this).next().find('.kd-pbox__items').slick('setPosition');
			}
		});

		$('.js-creators-slick').slick({
			dots: true,
			infinite: false,
			responsive: [{
				breakpoint: BREAK_POINTS.ltSP,
				settings: {
					arrows:false,
					variableWidth: true,
				}
			}]
		});

		if(window.innerWidth < BREAK_POINTS.ltSP) {
			$('.js-mv-slick').slick({
				fade: true,
				arrows:false,
				infinite: true,
				autoplay: true,
				speed: 1500
			});
			$('.js-sp-slick').slick({
				arrows:false,
				dots: true,
				variableWidth: true,
				infinite: false
			});

		}
  });

	window.onload = function() {

		const ttH = $('.js-class-toggle-target').height();
		const yyH = $('.js-class-toggle-target div').height();

		$('.js-class-toggle').on('click', function() {
			$(this).toggleClass('is-open');
			$('.js-class-toggle-target').toggleClass('is-open');
			$(this).find('.kd-icon').toggleClass('is')
			if($('.js-class-toggle-target').hasClass('is-open')) {
				$('.js-class-toggle-target').css({'height':yyH+'px'});
			} else {
				$('.js-class-toggle-target').css({'height':ttH+'px'})
			}
		});

		if(window.innerWidth < BREAK_POINTS.ltSP) {
			$('.js-sp-slick-1').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				infinite: false
			});
		} else {
			setTimeout(function() {
				$('.js-lazy-hide').hide();
				if(window.innerWidth < BREAK_POINTS.ltSP) {
					$('.js-lazy-sp-hide').hide();
				}
			}, 300);
		}

		$('.js-slick-1').slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			dots: true,
			variableWidth: true,
			infinite: false,
			responsive: [{
				breakpoint: BREAK_POINTS.ltSP,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: false,
				}
			}]
		});

		$('.js-slick-glass').each(function() {
			const slickItem = $(this).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				infinite: true,
				arrows: false
			});

			slickItem.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				slickItem.next().find('button').attr('aria-selected', 'false');
				slickItem.next().find('button:eq('+nextSlide+')').attr('aria-selected', 'true');
			});
			slickItem.next().find('button').on('click', function() {
				const index = slickItem.next().find('button').index(this);
				slickItem.slick('slickGoTo', index);
			})
		});
		setTimeout(function() {
			$('.js-lazy-hide').hide();
			if(window.innerWidth < BREAK_POINTS.ltSP) {
				$('.js-lazy-sp-hide').hide();
			}
		});

		$(window).on('kidstabChanged',function(e,o) {
			// o.find('.js-slick-glass').slick('slickGoTo', 2, true);
			if( Number($(o).attr('data-count')) <= 1 ) {
				$(o).find('.js-slick-glass').slick('setPosition');
			}
		});

	}

})();
